var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0354004,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1042 29.4728C29.7917 29.4416 28.5104 29.4416 27.1979 29.4728C26.9167 29.4728 26.8542 29.4103 26.8542 29.1291C26.8542 26.8166 26.8542 24.4728 26.8542 22.1603C26.8542 21.6291 26.8229 21.0978 26.6667 20.5978C26.1979 18.9728 24.3229 18.3791 22.9792 19.4728C22.2604 20.0353 21.9792 20.8166 21.9792 21.7541C21.9792 23.9416 21.9792 26.1291 21.9792 28.3166C21.9792 28.5978 21.9479 28.8791 21.9792 29.1916C22.0104 29.4416 21.8854 29.5041 21.6667 29.4728C20.3229 29.4728 19.0104 29.4728 17.6667 29.4728C17.4167 29.4728 17.3542 29.4103 17.3542 29.1603C17.3854 27.1916 17.3854 25.2228 17.3854 23.2228C17.3854 20.7853 17.3854 18.3478 17.3542 15.9416C17.3542 15.6603 17.4167 15.5978 17.6667 15.5978C19.0104 15.5978 20.3229 15.5978 21.6667 15.5978C21.9167 15.5978 21.9792 15.6603 21.9792 15.9103C21.9792 16.4103 21.9792 16.9103 21.9792 17.5041C22.0729 17.4103 22.1042 17.3791 22.1354 17.3478C23.3542 15.5666 25.0729 15.0666 27.1042 15.3791C29.4479 15.7541 30.9479 17.3791 31.3229 19.8791C31.4167 20.4728 31.4479 21.0666 31.4479 21.6603C31.4479 24.1603 31.4479 26.6291 31.4479 29.1291C31.4479 29.3791 31.3854 29.4728 31.1042 29.4728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8542 22.5354C14.8542 24.7229 14.8542 26.9104 14.8542 29.0979C14.8542 29.3792 14.7917 29.4729 14.5104 29.4729C13.1979 29.4417 11.8854 29.4729 10.5729 29.4729C10.3229 29.4729 10.2604 29.4104 10.2604 29.1604C10.2604 24.7542 10.2604 20.3167 10.2604 15.9104C10.2604 15.6917 10.3229 15.5979 10.5729 15.5979C11.9167 15.5979 13.2604 15.5979 14.6042 15.5979C14.8854 15.5979 14.9167 15.6917 14.9167 15.9417C14.8542 18.1292 14.8542 20.3167 14.8542 22.5354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0729 11.9729C14.7604 13.2229 13.4792 13.9417 12.0104 13.6917C10.4479 13.4417 9.57293 11.9104 10.1354 10.4104C10.5104 9.47292 11.4167 8.91042 12.5729 8.94167C14.3229 8.91042 15.4792 10.3167 15.0729 11.9729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.79a28871c50cc89dcce1403bdc694987.svg";
export { ForwardRef as ReactComponent };